import axios from 'axios';

export const axiosPostData = (url: string, formData: FormData) => axios.post(url, formData);
